import { safeDeleteSheet } from "@/lib/office-helpers";

export async function startProject10(): Promise<void> {
  await Excel.run(async (context) => {
    await safeDeleteSheet(context, "Encontrar un instructor");
    await safeDeleteSheet(context, "Cursos");

    // ─── SHEET 1: Encontrar un instructor ───
    const sheet1 = context.workbook.worksheets.add("Encontrar un instructor");

    // Title area (rows 2-3 merged, red background)
    sheet1.getRange("A2:B3").merge();
    sheet1.getRange("A2").values = [["Encontrar un instructor"]];
    sheet1.getRange("A2:B3").format.fill.color = "#FF0000";
    sheet1.getRange("A2").format.font.color = "#FFFFFF";
    sheet1.getRange("A2").format.font.size = 20;
    sheet1.getRange("A2").format.font.bold = true;
    sheet1.getRange("A2").format.horizontalAlignment = "Center";
    sheet1.getRange("A2").format.verticalAlignment = "Center";
    sheet1.getRange("2:3").format.rowHeight = 28;

    // Lookup form
    sheet1.getRange("A6").values = [["Nombre del curso:"]];
    sheet1.getRange("A6").format.fill.color = "#FF0000";
    sheet1.getRange("A6").format.font.color = "#FFFFFF";
    sheet1.getRange("A6").format.font.bold = true;
    sheet1.getRange("B6").values = [["Buceador de naufragios"]];

    sheet1.getRange("A8").values = [["Instructor:"]];
    sheet1.getRange("A8").format.fill.color = "#FF0000";
    sheet1.getRange("A8").format.font.color = "#FFFFFF";
    sheet1.getRange("A8").format.font.bold = true;
    // B8 empty — student fills with VLOOKUP formula

    // Border for B8
    sheet1.getRange("B6").format.borders.getItem("EdgeBottom").style = "Continuous";
    sheet1.getRange("B8").format.borders.getItem("EdgeBottom").style = "Continuous";

    sheet1.getRange("A:A").format.columnWidth = 140;
    sheet1.getRange("B:B").format.columnWidth = 200;

    sheet1.tabColor = "#FF0000";

    await context.sync();

    // ─── SHEET 2: Cursos ───
    const sheet2 = context.workbook.worksheets.add("Cursos");

    // Title area (rows 2-3 merged, red/black background)
    sheet2.getRange("A2:B3").merge();
    sheet2.getRange("A2").values = [["Catalogo de cursos SCUBA"]];
    sheet2.getRange("A2:B3").format.fill.color = "#000000";
    sheet2.getRange("A2").format.font.color = "#FFFFFF";
    sheet2.getRange("A2").format.font.size = 22;
    sheet2.getRange("A2").format.font.bold = true;
    sheet2.getRange("A2").format.font.italic = true;
    sheet2.getRange("A2").format.horizontalAlignment = "Center";
    sheet2.getRange("A2").format.verticalAlignment = "Center";
    sheet2.getRange("2:3").format.rowHeight = 28;

    // ── Section 1: Curso basico (rows 6-12) ──
    sheet2.getRange("A6").values = [["Curso basico"]];
    sheet2.getRange("B6").values = [["Nombre del instructor"]];
    sheet2.getRange("A6:B6").format.fill.color = "#FF0000";
    sheet2.getRange("A6:B6").format.font.color = "#FFFFFF";
    sheet2.getRange("A6:B6").format.font.bold = true;

    const basicCourses: string[][] = [
      ["Buceador en agua abierta (10+ años)", "Mike Finney"],
      ["Buceador avanzado en agua abierta", "Dan Webster"],
      ["Buceador de aventura", "Steve Riley"],
      ["Buceador de rescate", "Sam Barlow"],
      ["Buceador maestro", "Dan Webster"],
      ["Proveedor de la primera respuesta de emergencia", "Sam Barlow"],
    ];
    sheet2.getRange("A7:B12").values = basicCourses;
    sheet2.getRange("A7:B12").format.borders.getItem("InsideHorizontal").style = "Continuous";
    sheet2.getRange("A7:B12").format.borders.getItem("EdgeBottom").style = "Continuous";

    // ── Section 2: Curso especializado (rows 14-26) ──
    sheet2.getRange("A14").values = [["Curso especializado"]];
    sheet2.getRange("B14").values = [["Nombre del instructor"]];
    sheet2.getRange("A14:B14").format.fill.color = "#FF0000";
    sheet2.getRange("A14:B14").format.font.color = "#FFFFFF";
    sheet2.getRange("A14:B14").format.font.bold = true;

    const specializedCourses: string[][] = [
      ["Buceador", "Steve Riley"],
      ["Fotógrafo subacuático digital", "Sheila Noakes"],
      ["Especialista en equipos", "Kevin Hart"],
      ["Buceador nocturno", "Steve Riley"],
      ["Buceador de naufragios", "Dan Webster"],
      ["Buceador profundo", "Dan Webster"],
      ["Buceador de deriva", "Dan Webster"],
      ["Buceador de aire enriquecido", "Sam Barlow"],
      ["Buceador rebreather", "Sam Barlow"],
      ["Buceador de búsqueda y recuperación", "Sam Barlow"],
      ["Naturalista subacuático", "Sheila Noakes"],
      ["Navegador subacuático", "Steve Riley"],
    ];
    sheet2.getRange("A15:B26").values = specializedCourses;
    sheet2.getRange("A15:B26").format.borders.getItem("InsideHorizontal").style = "Continuous";
    sheet2.getRange("A15:B26").format.borders.getItem("EdgeBottom").style = "Continuous";

    // ── Section 3: Curso juvenil (rows 28-31) ──
    sheet2.getRange("A28").values = [["Curso juvenil"]];
    sheet2.getRange("B28").values = [["Nombre del instructor"]];
    sheet2.getRange("A28:B28").format.fill.color = "#FF0000";
    sheet2.getRange("A28:B28").format.font.color = "#FFFFFF";
    sheet2.getRange("A28:B28").format.font.bold = true;

    const youthCourses: string[][] = [
      ["Fabricante de burbujas (8+ años)", "Sheila Noakes"],
      ["Equipo de sellos (8+ años)", "Sheila Noakes"],
      ["Descubre el Buceo (10+ años)", "Mike Finney"],
    ];
    sheet2.getRange("A29:B31").values = youthCourses;
    sheet2.getRange("A29:B31").format.borders.getItem("InsideHorizontal").style = "Continuous";
    sheet2.getRange("A29:B31").format.borders.getItem("EdgeBottom").style = "Continuous";

    // Column widths
    sheet2.getRange("A:A").format.columnWidth = 260;
    sheet2.getRange("B:B").format.columnWidth = 170;

    sheet2.tabColor = "#FF0000";

    await context.sync();

    // Activate first sheet
    sheet1.activate();
    sheet1.getRange("A1").select();

    await context.sync();
  });
}
